import HCheckArray from "@rf-helper/check-have-value";

import { C_BUSINESS_TYPE } from "@/src-refactor/modules/shared/model/const/property/business-type.const";
import featureIndicators from "./model/feature-indicators";
import { I_GENERIC_ITEMS } from "@/src-refactor/modules/shared/model/interface/items.interface";
import { C_YES_AND_NOT } from "@/src-refactor/modules/shared/model/const/yes-and-not.conts";
import { C_STATUS_TRUST } from "../septions/property-steps/documentation-step/validations-project/validation-documents/models/trust.const";
import { IPropertyForm } from "./schemas/property-schema/propertySchema";
import { CPropertyFormKeys } from "./schemas/property-schema/propertySchema";
import { checkTypeSale, fileIsRequiredWhenIsRent } from "./schemas/helps";
import { checkTypeRent } from "./schemas/helps";

const CRealEstateRequiredFields: {
  [K in keyof typeof CPropertyFormKeys]: (_form: IPropertyForm) => boolean;
} = {
  //generic
  [CPropertyFormKeys.id_property]: (_form: IPropertyForm) => false,
  [CPropertyFormKeys.is_project]: (_form: IPropertyForm) => true,
  [CPropertyFormKeys.is_edit]: (_form: IPropertyForm) => true,

  //locations
  [CPropertyFormKeys.owners_property]: (_form: IPropertyForm) => true,
  [CPropertyFormKeys.city_property]: (_form: IPropertyForm) => true,
  [CPropertyFormKeys.address_property]: (_form: IPropertyForm) => true,
  [CPropertyFormKeys.sector_property]: (_form: IPropertyForm) => true,
  [CPropertyFormKeys.reference_point_property]: (_form: IPropertyForm) => false,
  [CPropertyFormKeys.position_property]: (_form: IPropertyForm) =>
    IfPropertyIs(featureIndicators.positions, _form),
  [CPropertyFormKeys.longitude_property]: (_form: IPropertyForm) => true,
  [CPropertyFormKeys.latitude_property]: (_form: IPropertyForm) => true,

  //details
  [CPropertyFormKeys.type_property]: (_form: IPropertyForm) => true,
  [CPropertyFormKeys.name_property]: (_form: IPropertyForm) => true,
  [CPropertyFormKeys.business_types_property]: (_form: IPropertyForm) => true,
  [CPropertyFormKeys.detail_business_property]: (_form: IPropertyForm) => true,
  [CPropertyFormKeys.uses_property]: (_form: IPropertyForm) => true,
  [CPropertyFormKeys.condition_property]: (_form: IPropertyForm) => true,
  [CPropertyFormKeys.associates_type_property]: (_form: IPropertyForm) => true,
  [CPropertyFormKeys.arrangement_type_property]: (_form: IPropertyForm) => true,
  [CPropertyFormKeys.meter_construction_property]: (_form: IPropertyForm) =>
    IfPropertyIs(featureIndicators.meterConstruction, _form),
  [CPropertyFormKeys.meter_land_property]: (_form: IPropertyForm) =>
    IfPropertyIs(featureIndicators.meterLand, _form),
  [CPropertyFormKeys.visit_type_property]: (_form: IPropertyForm) => true,
  [CPropertyFormKeys.is_habited_property]: (_form: IPropertyForm) => true,
  [CPropertyFormKeys.currency_sale_property]: (_form: IPropertyForm) =>
    IfBusinessTypeIsSale(_form),
  [CPropertyFormKeys.price_sale_property]: (_form: IPropertyForm) =>
    IfBusinessTypeIsSale(_form),
  [CPropertyFormKeys.currency_rent_property]: (_form: IPropertyForm) =>
    IfBusinessTypeIsRent(_form),
  [CPropertyFormKeys.price_rent_property]: (_form: IPropertyForm) =>
    IfBusinessTypeIsRent(_form),
  [CPropertyFormKeys.brokers_property]: (_form: IPropertyForm) => true,
  [CPropertyFormKeys.currency_maintenance_property]: (_form: IPropertyForm) =>
    IfPropertyIs([], _form),

  [CPropertyFormKeys.price_maintenance_property]: (_form: IPropertyForm) =>
    IfPropertyIs([], _form),

  [CPropertyFormKeys.fee_sale_percentage_commission_property]: (
    _form: IPropertyForm
  ) => IfBusinessTypeIsSale(_form),

  [CPropertyFormKeys.fee_sale_selling_agent_commission_percentage]: (
    _form: IPropertyForm
  ) => IfBusinessTypeIsSale(_form),

  [CPropertyFormKeys.fee_rent]: (_form: IPropertyForm) =>
    IfBusinessTypeIsRent(_form),

  [CPropertyFormKeys.is_study_property]: (_form: IPropertyForm) =>
    IfPropertyIs(featureIndicators.studio, _form),

  [CPropertyFormKeys.is_collection_property]: (_form: IPropertyForm) => false,

  [CPropertyFormKeys.characteristics_frames_property]: (_form: IPropertyForm) =>
    IfPropertyIs(featureIndicators.frames, _form) && !_form.is_project,

  [CPropertyFormKeys.characteristics_closets_property]: (_form: IPropertyForm) =>
    IfPropertyIs(featureIndicators.closets, _form) && !_form.is_project,

  [CPropertyFormKeys.characteristics_door_property]: (_form: IPropertyForm) =>
    IfPropertyIs(featureIndicators.doors, _form) && !_form.is_project,

  [CPropertyFormKeys.characteristics_windows_property]: (_form: IPropertyForm) =>
    IfPropertyIs(featureIndicators.windows, _form) && !_form.is_project,

  [CPropertyFormKeys.characteristics_cabinets_property]: (_form: IPropertyForm) =>
    IfPropertyIs(featureIndicators.cabinets, _form) && !_form.is_project,

  [CPropertyFormKeys.characteristics_floors_property]: (_form: IPropertyForm) =>
    IfPropertyIs(featureIndicators.floors, _form) && !_form.is_project,

  [CPropertyFormKeys.characteristics_roof_property]: (_form: IPropertyForm) =>
    IfPropertyIs(featureIndicators.roof, _form) && !_form.is_project,

  [CPropertyFormKeys.characteristics_roof_form_property]: (_form: IPropertyForm) =>
    IfPropertyIs(featureIndicators.roofForm, _form) && !_form.is_project,

  [CPropertyFormKeys.characteristics_type_house_property]: (_form: IPropertyForm) =>
    IfPropertyIs(featureIndicators.houseType, _form) && !_form.is_project,

  [CPropertyFormKeys.tareas_property]: (_form: IPropertyForm) => false,

  [CPropertyFormKeys.want_publish_on_alterestate]: (_form: IPropertyForm) => false,
  [CPropertyFormKeys.want_publish_on_internal_alterestate]: (_form: IPropertyForm) =>
    false,
  [CPropertyFormKeys.garante_commission_alterestate]: (_form: IPropertyForm) =>
    false,

  [CPropertyFormKeys.features_property]: (_form: IPropertyForm) => false,
  [CPropertyFormKeys.bedrooms_property]: (_form: IPropertyForm) =>
    IfPropertyIs(featureIndicators.bedrooms, _form),
  [CPropertyFormKeys.bathrooms_property]: (_form: IPropertyForm) =>
    IfPropertyIs(featureIndicators.bathrooms, _form),
  [CPropertyFormKeys.half_bathrooms_property]: (_form: IPropertyForm) =>
    IfPropertyIs(featureIndicators.halfBathrooms, _form),
  [CPropertyFormKeys.parking_spots_property]: (_form: IPropertyForm) =>
    IfPropertyIs(featureIndicators.parkingSpots, _form),
  [CPropertyFormKeys.pumps_property]: (_form: IPropertyForm) =>
    IfPropertyIs(featureIndicators.pumps, _form),
  [CPropertyFormKeys.level_floor_property]: (_form: IPropertyForm) =>
    IfPropertyIs(featureIndicators.levelFloor, _form),
  [CPropertyFormKeys.total_floor_property]: (_form: IPropertyForm) =>
    IfPropertyIs(featureIndicators.totalLevels, _form),

  // seo
  [CPropertyFormKeys.seo_title_en_property]: (_form: IPropertyForm) => true,
  [CPropertyFormKeys.seo_short_description_en_property]: (_form: IPropertyForm) =>
    false,
  [CPropertyFormKeys.seo_description_en_property]: (_form: IPropertyForm) => true,
  [CPropertyFormKeys.seo_keywords_en_property]: (_form: IPropertyForm) => false,

  [CPropertyFormKeys.seo_title_es_property]: (_form: IPropertyForm) => true,
  [CPropertyFormKeys.seo_short_description_es_property]: (_form: IPropertyForm) =>
    false,
  [CPropertyFormKeys.seo_description_es_property]: (_form: IPropertyForm) => true,
  [CPropertyFormKeys.seo_keywords_es_property]: (_form: IPropertyForm) => false,

  //documents
  [CPropertyFormKeys.registration_number]: (_form: IPropertyForm) => false,
  [CPropertyFormKeys.have_mortgage_property]: (_form: IPropertyForm) => true,
  [CPropertyFormKeys.notes_property]: (_form: IPropertyForm) => false,

  [CPropertyFormKeys.file_title_property]: (_form: IPropertyForm) => {
    if (HCheckArray(_form.file_property_contract_property)) {
      return false;
    }
    if (
      HCheckArray(_form.business_types_property) &&
      checkTypeSale(_form.business_types_property as any, _form.is_project)
    ) {
      return true;
    } else if (
      checkTypeRent(_form.business_types_property as any, _form.is_project)
    ) {
      return fileIsRequiredWhenIsRent(CPropertyFormKeys.file_title_property);
    } else {
      return true;
    }
  },

  [CPropertyFormKeys.file_capture_details_property]: (_form: IPropertyForm) => {
    if (checkTypeRent(_form.business_types_property as any, _form.is_project)) {
      return fileIsRequiredWhenIsRent(
        CPropertyFormKeys.file_capture_details_property
      );
    } else {
      return true;
    }
  },

  [CPropertyFormKeys.file_owner_id_property]: (_form: IPropertyForm) => {
    if (checkTypeRent(_form.business_types_property as any, _form.is_project)) {
      return fileIsRequiredWhenIsRent(CPropertyFormKeys.file_owner_id_property);
    } else {
      return true;
    }
  },

  [CPropertyFormKeys.file_application_form_property]: (_form: IPropertyForm) => {
    if (checkTypeRent(_form.business_types_property as any, _form.is_project)) {
      return fileIsRequiredWhenIsRent(
        CPropertyFormKeys.file_application_form_property
      );
    } else {
      return true;
    }
  },

  [CPropertyFormKeys.file_power_ownership_property]: (_form: IPropertyForm) => {
    if (checkTypeRent(_form.business_types_property as any, _form.is_project)) {
      return fileIsRequiredWhenIsRent(
        CPropertyFormKeys.file_power_ownership_property
      );
    } else {
      return false;
    }
  },

  [CPropertyFormKeys.file_commercial_registry_property]: (_form: IPropertyForm) => {
    if (checkTypeRent(_form.business_types_property as any, _form.is_project)) {
      return fileIsRequiredWhenIsRent(
        CPropertyFormKeys.file_commercial_registry_property
      );
    } else {
      return false;
    }
  },

  [CPropertyFormKeys.file_property_contract_property]: (_form: IPropertyForm) => {
    if (checkTypeRent(_form.business_types_property as any, _form.is_project)) {
      return fileIsRequiredWhenIsRent(
        CPropertyFormKeys.file_property_contract_property
      );
    } else {
      return false;
    }
  },

  //multimedia
  [CPropertyFormKeys.images_property]: (_form: IPropertyForm) => true,
  [CPropertyFormKeys.videos_property]: (_form: IPropertyForm) => false,
  [CPropertyFormKeys.tour_virtual_property]: (_form: IPropertyForm) => false,
  [CPropertyFormKeys.dropbox_link_property]: (_form: IPropertyForm) => false,
  [CPropertyFormKeys.drive_link_property]: (_form: IPropertyForm) => false,

  [CPropertyFormKeys.building]: (_form: IPropertyForm) => false,

  [CPropertyFormKeys.master_broker_property]: (_form: IPropertyForm) => false,
  [CPropertyFormKeys.price_separation_property]: (_form: IPropertyForm) =>
    _form.is_project,
  [CPropertyFormKeys.deadline_property]: (_form: IPropertyForm) => _form.is_project,
  [CPropertyFormKeys.currency_separation_property]: (_form: IPropertyForm) => false,

  // validation documents
  [CPropertyFormKeys.file_master_plan]: (_form: IPropertyForm) => false,
  [CPropertyFormKeys.trust_has_trustee]: (_form: IPropertyForm) => _form.is_project,
  [CPropertyFormKeys.trust_name_trustee]: (_form: IPropertyForm) => {
    if (!_form.is_project) return false;
    const { YES, PENDING } = getResponseHasTrust(_form.trust_has_trustee);
    const { YES_MEETING } = getResponseHasMeetingTrust(
      _form.trust_has_meeting_trustee
    );
    return YES || PENDING || YES_MEETING;
  },
  [CPropertyFormKeys.trust_name_official_trustee]: (_form: IPropertyForm) => {
    if (!_form.is_project) return false;
    const { YES, PENDING } = getResponseHasTrust(_form.trust_has_trustee);
    const { YES_MEETING } = getResponseHasMeetingTrust(
      _form.trust_has_meeting_trustee
    );
    return YES || PENDING || YES_MEETING;
  },
  [CPropertyFormKeys.trust_email_trustee]: (_form: IPropertyForm) => {
    if (!_form.is_project) return false;
    const { YES, PENDING } = getResponseHasTrust(_form.trust_has_trustee);
    return YES || PENDING;
  },
  [CPropertyFormKeys.trust_has_meeting_trustee]: (_form: IPropertyForm) => true,
  [CPropertyFormKeys.trust_entity_has_meeting_trustee]: (_form: IPropertyForm) => {
    const { YES_MEETING } = getResponseHasMeetingTrust(
      _form.trust_has_meeting_trustee
    );
    return YES_MEETING;
  },
  [CPropertyFormKeys.trust_oficial_name_meeting_trustee]: (_form: IPropertyForm) => {
    const { YES_MEETING } = getResponseHasMeetingTrust(
      _form.trust_has_meeting_trustee
    );
    return YES_MEETING;
  },
  [CPropertyFormKeys.trust_date_meeting_trustee]: (_form: IPropertyForm) => {
    if (!_form.is_project) return false;
    const { YES_MEETING } = getResponseHasMeetingTrust(
      _form.trust_has_meeting_trustee
    );
    return YES_MEETING;
  },
  [CPropertyFormKeys.trust_notes_trustee]: (_form: IPropertyForm) => false,
  [CPropertyFormKeys.trust_rnc_trustee]: (_form: IPropertyForm) => false,
  [CPropertyFormKeys.trust_estimated_constitution_date]: (_form: IPropertyForm) =>
    false,
  [CPropertyFormKeys.file_definitive_trustee]: (_form: IPropertyForm) => false,
  [CPropertyFormKeys.date_file_definitive_trustee]: (_form: IPropertyForm) => {
    if (!_form.is_project) return false;
    return HCheckArray(_form.file_definitive_trustee);
  },
  [CPropertyFormKeys.file_title_transfer_trustee]: (_form: IPropertyForm) => false,
  [CPropertyFormKeys.file_tax_receipt]: (_form: IPropertyForm) => false,
  [CPropertyFormKeys.file_deposit_in_town_hall]: (_form: IPropertyForm) => false,
  [CPropertyFormKeys.date_deposit_town_hall]: (_form: IPropertyForm) => {
    if (!_form.is_project) return false;
    return HCheckArray(_form.file_deposit_in_town_hall);
  },
  [CPropertyFormKeys.file_no_objection_from_town_hall]: (_form: IPropertyForm) =>
    false,
  [CPropertyFormKeys.date_no_objection_issuance]: (_form: IPropertyForm) => {
    if (!_form.is_project) return false;
    return HCheckArray(_form.file_no_objection_from_town_hall);
  },
  [CPropertyFormKeys.has_confotur]: (_form: IPropertyForm) => true,
  [CPropertyFormKeys.file_definitive_confotur]: (_form: IPropertyForm) => false,
  [CPropertyFormKeys.date_file_definitive_confotur]: (_form: IPropertyForm) => {
    if (!_form.is_project) return false;
    return HCheckArray(_form.file_definitive_confotur);
  },
  [CPropertyFormKeys.file_previous_mitur]: (_form: IPropertyForm) => false,
  [CPropertyFormKeys.date_file_previous_mitur]: (_form: IPropertyForm) => {
    if (!_form.is_project) return false;
    return HCheckArray(_form.file_previous_mitur);
  },
  [CPropertyFormKeys.file_environment]: (_form: IPropertyForm) => false,
  [CPropertyFormKeys.date_file_environment]: (_form: IPropertyForm) => {
    if (!_form.is_project) return false;
    return HCheckArray(_form.file_environment);
  },
  [CPropertyFormKeys.file_evidence_earth_movement]: (_form: IPropertyForm) => false,
  [CPropertyFormKeys.date_file_evidence_earth_movement]: (_form: IPropertyForm) => {
    if (!_form.is_project) return false;
    return HCheckArray(_form.file_evidence_earth_movement);
  },
  [CPropertyFormKeys.file_construction_license]: (_form: IPropertyForm) => false,
  [CPropertyFormKeys.date_construction_license]: (_form: IPropertyForm) => {
    if (!_form.is_project) return false;
    return HCheckArray(_form.file_construction_license);
  },
  [CPropertyFormKeys.file_commercial_register]: (_form: IPropertyForm) => false,
  [CPropertyFormKeys.date_file_commercial_register]: (_form: IPropertyForm) => {
    if (!_form.is_project) return false;
    return HCheckArray(_form.file_commercial_register);
  },
  [CPropertyFormKeys.feature_project_property]: (_form: IPropertyForm) => false,
  [CPropertyFormKeys.file_construction_cv]: (_form: IPropertyForm) => false,
  [CPropertyFormKeys.name_construction_company]: (_form: IPropertyForm) => false,
  [CPropertyFormKeys.file_assembly_minutes]: (_form: IPropertyForm) => false,
  [CPropertyFormKeys.file_due_diligence]: (_form: IPropertyForm) => false,
  [CPropertyFormKeys.file_credit_bureau]: (_form: IPropertyForm) => false,
  [CPropertyFormKeys.file_rnc_construction]: (_form: IPropertyForm) => false,
  [CPropertyFormKeys.rnc_construction]: (_form: IPropertyForm) => false,
  [CPropertyFormKeys.file_legal_status]: (_form: IPropertyForm) => false,
  [CPropertyFormKeys.date_file_legal_status]: (_form: IPropertyForm) => {
    if (!_form.is_project) return false;
    return HCheckArray(_form.file_legal_status);
  },
  [CPropertyFormKeys.file_purchase_sale_land]: (_form: IPropertyForm) => false,
  [CPropertyFormKeys.date_file_purchase_sale_land]: (_form: IPropertyForm) => {
    if (!_form.is_project) return false;
    return HCheckArray(_form.file_purchase_sale_land);
  },
  [CPropertyFormKeys.type_association_acoprovi]: (_form: IPropertyForm) => true,
  [CPropertyFormKeys.file_acoprovi]: (_form: IPropertyForm) => false,
  [CPropertyFormKeys.date_file_acoprovi]: (_form: IPropertyForm) => {
    if (!_form.is_project) return false;
    return HCheckArray(_form.file_acoprovi);
  },
  [CPropertyFormKeys.file_aprocovici]: (_form: IPropertyForm) => false,
  [CPropertyFormKeys.date_file_aprocovici]: (_form: IPropertyForm) => {
    if (!_form.is_project) return false;
    return HCheckArray(_form.file_aprocovici);
  }
} as any;
// TODO - Check if this is the correct return type
export default CRealEstateRequiredFields;

const IfPropertyIs = (arg: number[], _form: IPropertyForm) => {
  return (
    HCheckArray(_form.type_property) &&
    arg.includes(_form.type_property[0].id as number)
  );
};

const IfBusinessTypeIs = (arg: number[], _form: IPropertyForm) => {
  return (
    HCheckArray(_form.business_types_property) &&
    arg.includes(_form.type_property[0].id as number)
  );
};
const IfBusinessTypeIsSale = (_form: IPropertyForm) => {
  return (
    HCheckArray(_form.business_types_property) &&
    [C_BUSINESS_TYPE.SALE.id, C_BUSINESS_TYPE.SALE_AND_SELL.id].includes(
      _form.business_types_property[0].id as number
    )
  );
};
const IfBusinessTypeIsRent = (_form: IPropertyForm) => {
  return (
    HCheckArray(_form.business_types_property) &&
    [C_BUSINESS_TYPE.SELL.id, C_BUSINESS_TYPE.SALE_AND_SELL.id].includes(
      _form.business_types_property[0].id as number
    )
  );
};

export const getPropertyRequiredFields = (form: IPropertyForm) => {
  return Object.keys(CRealEstateRequiredFields).filter(key =>
    CRealEstateRequiredFields[key as keyof typeof CPropertyFormKeys](form)
  );
};

const getResponseHasTrust = (hasTrust: I_GENERIC_ITEMS[]) => {
  const { YES, NO, PENDING } = C_STATUS_TRUST;
  if (HCheckArray(hasTrust)) {
    return {
      YES: hasTrust[0].value === YES.value,
      NO: hasTrust[0].value === NO.value,
      PENDING: hasTrust[0].value === PENDING.value
    };
  } else {
    return {
      YES: false,
      NO: false,
      PENDING: false
    };
  }
};

const getResponseHasMeetingTrust = (hasMeetingTrust: I_GENERIC_ITEMS[]) => {
  const { YES, NOT } = C_YES_AND_NOT;
  if (HCheckArray(hasMeetingTrust)) {
    return {
      YES_MEETING: hasMeetingTrust[0].value === YES.value,
      NOT_MEETING: hasMeetingTrust[0].value === NOT.value
    };
  } else {
    return {
      YES_MEETING: false,
      NOT_MEETING: false
    };
  }
};
